import type { TourConfig } from '../../types/tour.types'

// User Credits (balances, allocation, history). Anchors are `data-tour` attributes on the view
// (added alongside this tour). Context first, then where to read balances and share them out.
const userCreditsTour: TourConfig = {
  id: 'user-credits',
  title: 'Track and share out your credits',
  module: 'Account',
  routeName: 'UserCredits',
  order: 21,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Know exactly what you have to spend',
      body: 'Credits power your **exports and mobile reveals**. This page shows your balances, how they are split across the team, and how to **request more** — so prospecting never stalls unexpectedly.',
    },
    {
      id: 'tabs',
      target: '[data-tour="uc-tabs"]',
      placement: 'bottom',
      title: 'TAMI and API credits',
      body: 'Switch between **TAMI Credits** for everyday prospecting and **API Credits** for integration usage. API appears only when your plan includes API access.',
    },
    {
      id: 'overview',
      target: '[data-tour="uc-overview"]',
      placement: 'bottom',
      title: 'Balances at a glance',
      body: 'See your **total, used and remaining** credits at a glance, and **request more** from your account manager the moment you are running low.',
    },
    {
      id: 'allocation',
      target: '[data-tour="uc-allocation"]',
      placement: 'top',
      title: 'Share credits across your team',
      body: 'Allocate credits to each user with the sliders, then **Save**. Give heavier users more and keep everyone productive without over-spending.',
    },
    {
      id: 'help',
      target: '[data-tour="uc-help"]',
      placement: 'bottom',
      title: 'Help when you need it',
      body: 'Stuck on anything credit-related? **Help** opens tutorials, FAQs and a support form in a new tab — your current work stays right where it is.',
    },
  ],
}

export default userCreditsTour
